import React from 'react';

import { ICustomOptionProps } from 'common/components/FieldGenerator/types';
import classNames from 'classnames';
import styles from './styles.module.scss';

const ConnectionSizeOption = ({
  option: { title, attributes },
}: ICustomOptionProps) => {
  const attrs = (attributes || {}) as Record<string, string>;
  const attrCount = [attrs?.title2].filter((v) => !!v).length;
  const gridClass = classNames({
    [styles.content]: true,
    [styles.content2]: attrCount === 1,
    [styles.content3]: attrCount === 2,
  });
  return (
    <div className={gridClass}>
      {attrs?.title2
          && (
            <span>
              <small>{attrs?.caption_left || 'Dash Size'}</small>
              <br />
              {attrs?.title2}
            </span>
          )}
      <span className={styles.more}>
        <small>{attrs?.caption_right || 'Connection Size'}</small>
        <br />
        {title || '-'}
      </span>
    </div>
  );
};
export default ConnectionSizeOption;
